module.exports = __webpack_public_path__ + "img/laurel-gitlen-2.bd7f7c4e.png";